const config = require("./config.json");
const { get } = require("./common").default;

/**
 * Filter and retrieve user hour logs based on dynamic criteria
 * @param {Object} filters
 * @param {number} [filters.user_id]
 * @param {number} [filters.project_id]
 * @param {string} [filters.vessel_id]
 * @param {boolean} [filters.enable_all] // Optional flag to enable fetching all records without filtering
 * @returns {Promise} Axios wrapper response promise
 */

exports.getUsersProjectsVessels = async (filters) => {
  const queryParams = new URLSearchParams(filters).toString();
  return await get(
    config.apis.baseUrl.url + "users/vessels/projects?" + queryParams
  );
};
